@if(showImg) {
@if(isMultipleFilesUpload){
@for(img of uploadedImg; track img;) {
@if (img && showImg) {
<!-- <app-mi-image-container class="img-preview" [miImage]="img" miWidth="170" id="preview"></app-mi-image-container> -->
}
}
}@else {

}

@if (formName?.controls[field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode]?.value?.length
&& field.attributeCode !== 'event_image') {
@if(field?.documentURLs){
@for(url of field?.documentURLs; track url; let i = $index){
<!-- <a [href]="url" target="_blank" class="view-doc" translate>View document {{i + 1}}</a><br> -->

}
}
}
<!-- @else{
<app-mi-image-container class="img-preview" [miImage]="img" miWidth="170" id="preview"></app-mi-image-container>
} -->
}

<form>
  <p-fileUpload
    class="cursor-pointer"
    mode="advanced"
    [chooseLabel]="chooseLabel"
    (onSelect)="onUpload($event, field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)"
    customUpload="true"
    [accept]="accept"
    [maxFileSize]="maxFileSize"
    [multiple]="isMultipleFilesUpload"
    [showCancelButton]="false"
    [showUploadButton]="false"
    [chooseIcon]="chooseIcon">
    <ng-template pTemplate="content" let-files>
      <div class="drop-area">
        @if (isMultipleFilesUpload && uploadedFiles.length >= 5) {
        <div class="max-files-reached">
          {{ cs.getLabel('lbl_max_files_limit_reached') || 'Maximum 5 files reached' }}
        </div>
        } @else {
        {{ isDocumentModule ? dropAreaMsgForDocument : dropAreaMsg }}
        }
      </div>
    </ng-template>
  </p-fileUpload>
</form>

<div>
  <div class="file-upload-instruction" translate>
    {{ isDocumentModule ? 'lbl_img_pdf_upload_instruction' : 'lbl_img_upload_instruction' }}
  </div>
  <div class="file-upload-instruction">
    {{ documentLimitMessage }}
  </div>
</div>

@if (uploadedFiles.length > 0) {
<div class="col-{{field.uiColumns === 12 ? 6 : 12}} file-list-div pl-0">
  <div class="card list">
    <div class="col-12 p-0 file-list px-2 py-2">
      <label>Uploaded Files</label>
    </div>
    <div class="grid flex ml-2 mr-2">
      @for (file of uploadedFiles; track file) {
      <div class="flex mt-3 mb-2" [class.existing-file]="file.isExisting">
        <div class="flex justify-content-between image-details w-full" style="width: 100%;">
          <div class="flex justify-content-start">
            <div class="flex align-items-center ml-2">
              <img
                [src]="'../../../../../../assets/images/mi-theme/light/basic/' + (file?.file?.type === 'application/pdf' ? 'pdf-logo.svg' : 'image.svg')">
            </div>
            <div class="flex align-items-center ml-2">
              <label [title]="file.file.name" class="ellipses">
                {{ file.file.name }}{{ (!isDocumentModule && !file.isExisting) ? ' - ' + file.file.size + ' bytes' : '' }}
              </label>
            </div>
          </div>
          <div class="flex justify-content-between align-items-center ml-2">
            @if (file.isExisting) {
            <a [href]="file.url" target="_blank" class="view-doc mr-2" translate>
              <div class="cursor-pointer mr-1 mt-1">
                <i class="{{miIcons.DOWNLOAD}} wh-18 inline-block bg-default-text-blue"></i>
              </div>
            </a>

            }
            <!-- <img (mouseover)="showCloseImageIcon()" (mouseout)="showCheckImageIcon()"
              src="../../../../../../assets/images/mi-theme/light/basic/basic_circle_check.svg"> -->
            <img (mouseover)="showCloseImageIcon()" (mouseout)="showCheckImageIcon()"
              (click)="removeImage(file, field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)"
              class="close-icon" src="../../../../../../assets/images/mi-theme/light/basic/off_close.svg">
            <!-- @if (isDocumentModule) {
            <div class="cursor-pointer mr-1 mt-1" (click)="downloadDocument(file)">
              <i class="{{miIcons.DOWNLOAD}} wh-18 inline-block bg-default-text-blue"></i>
            </div>
            } -->
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}

<form [formGroup]="formName">
  <p-toast key="fileupload" position="top-right"></p-toast>
  @if(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode && isFormReady){
  <input style="display: none;" type="text" pInputText
    [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
    class="w-full" />
  }
  <p-blockUI [blocked]="blockedDocument" />
</form>